import { render, staticRenderFns } from "./ModelConfPage.vue?vue&type=template&id=4473b1a4"
import script from "./ModelConfPage.vue?vue&type=script&lang=js"
export * from "./ModelConfPage.vue?vue&type=script&lang=js"
import style0 from "./ModelConfPage.vue?vue&type=style&index=0&id=4473b1a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports